// extracted by mini-css-extract-plugin
module.exports = {"section":"whatsappButton_section__CmN3H","container":"whatsappButton_container__pyeFk"};